/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Menu';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const MenuIcon = withMuiAdapter(Base, 'Menu');
